export default __webpack_public_path__ + "static/media/newone.4efa84c6.png";